import { useLocation } from '@thd-olt-component-react/router';
import { useConfigService } from '@thd-nucleus/experience-context';

export function useSlug(customerType, isNativeApp = false) {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const slugFromQueryParams = searchParams.get('slug');
  const debugTrue = searchParams.get('debug');

  const fsWorkspaceDashboardLayout = useConfigService('fs:workspaceDashboardLayout');

  /**
   * A slug in the query parameters means someone is trying to preview
   * the page using the preview button in Contentful.
   */
  if (debugTrue === 'true' && slugFromQueryParams) return slugFromQueryParams;

  if (customerType === 'b2b' && fsWorkspaceDashboardLayout) {
    if (isNativeApp) return `native-app-homepage-prod-${fsWorkspaceDashboardLayout}`;

    return `homepage-prod-${fsWorkspaceDashboardLayout}`;
  }

  if (isNativeApp) return `native-app-homepage-prod-${customerType}`;

  return `homepage-prod-${customerType}`;
}
